import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AppState } from '../types';
import type { ApiKeyStatus } from '../../types';
import { apiSlice } from '../api/apiSlice';
import { initializeApp } from '../thunks/sessionThunks';

const initialState: AppState = {
  isInitialized: false,
  apiStatus: null,
  globalError: null,
  isLoading: false,
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setGlobalError: (state, action: PayloadAction<string | null>) => {
      state.globalError = action.payload;
    },
    clearGlobalError: (state) => {
      state.globalError = null;
    },
    setInitialized: (state, action: PayloadAction<boolean>) => {
      state.isInitialized = action.payload;
    },
    setGlobalLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Handle initializeApp thunk
    builder
      .addCase(initializeApp.pending, (state) => {
        state.isLoading = true;
        state.globalError = null;
      })
      .addCase(initializeApp.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isInitialized = true;
        state.apiStatus = action.payload.apiStatus;
        state.globalError = null;
      })
      .addCase(initializeApp.rejected, (state, action) => {
        state.isLoading = false;
        state.isInitialized = false;
        state.globalError = action.payload || 'Failed to initialize application';
      });

    // Handle API key status query
    builder
      .addMatcher(apiSlice.endpoints.getApiKeyStatus.matchPending, (state) => {
        state.isLoading = true;
      })
      .addMatcher(apiSlice.endpoints.getApiKeyStatus.matchFulfilled, (state, action) => {
        state.apiStatus = action.payload;
        state.isLoading = false;
        state.globalError = null;
      })
      .addMatcher(apiSlice.endpoints.getApiKeyStatus.matchRejected, (state, action) => {
        state.isLoading = false;
        state.globalError = action.error.message || 'Failed to load API status';
      });
  },
});

export const { setGlobalError, clearGlobalError, setInitialized, setGlobalLoading } = appSlice.actions;
export default appSlice.reducer;